<script setup lang="ts">
/**
 * UI-kit component
 * Category: Brand
 * Name: BrandShapeIcon
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=325-8507
 *
 * A brand shape plate (SVG mask filled with a brand 500-primary token) with a centred
 * glyph slot. Per the Figma contract the glyph is a SLOT for any icon (no icon prop of
 * its own) and is always rendered icon/inverse — the slot wrapper enforces the color,
 * so both the DS Icon and AppIconStrapi (Strapi IconHub fields) work inside.
 * 9 shapes x 6 colors x 4 sizes; sizes follow Figma (lg 76/48, md 48/32, sm 40/32,
 * xs 32/24 — plate/glyph) and are overridable per breakpoint via the
 * --brand-shape-icon-size / --brand-shape-icon-glyph custom props.
 * Mirrors the shared Strapi component atoms.brand-shape-icon (icon, shape, color, size).
 */
// types
import type { BrandShapeIconProps } from '../types/interfaces'

defineOptions({
  name: 'BrandShapeIcon',
})

withDefaults(defineProps<BrandShapeIconProps>(), {
  shape: 'square',
  color: 'ultraviolet',
  size: 'lg',
})
</script>

<template>
  <span
    class="brand-shape-icon"
    :class="[
      `brand-shape-icon--${shape}`,
      `brand-shape-icon--${color}`,
      `brand-shape-icon--${size}`,
    ]"
  >
    <span class="brand-shape-icon__glyph">
      <slot />
    </span>
  </span>
</template>

<style lang="scss" scoped src="../styles/_brand-shape-icon.scss" />
